import { db } from '@/main';
import { firestoreAction } from 'vuexfire';

export default {
  namespaced: true,
  state: {
    carousel: {
      panorama: { records: [] },
    },
    // single poi
    record: [],
    // array of pois
    records: [],
    pagination: {
      // indicates that the end has been reached
      end: false,
      itemCount: 10,
      lastItem: null,
      loading: false,
    },
  },
  actions: {
    bindRecords: firestoreAction(({ bindFirestoreRef }, payload = {}) => {
      let ref = db.collection('pois');

      if ('doc' in payload) {
        ref = ref.doc(payload.doc);
        return bindFirestoreRef('record', ref);
      }

      if ('validated' in payload) {
        ref = ref.where('validated', '==', payload.validated);
      } else {
        // if there is to "validated" attribute in payload, default to "true"
        ref = ref.where('validated', '==', true);
      }

      if (payload.carousel) {
        ref = ref.orderBy('created_at', 'desc').limit(5);
      } else if (payload.uid) {
        // authenticated user
        if (payload.mypois) {
          ref = ref.where('created_by', '==', payload.uid);
        }
      } else {
        // anonymous user can see last 10 created POIs
        ref = ref.orderBy('created_at', 'desc').limit(10);
        // return query for anonymous users here (so ordering is not applied)
        return bindFirestoreRef('records', ref);
      }

      // ### ordering ###
      if ('order_by' in payload) {
        let order_dir = 'asc';
        if ('order_dir' in payload) {
          order_dir = payload.order_dir;
        }
        ref = ref.orderBy(payload.order_by, order_dir);
      }
      // limit results
      if ('limit' in payload) {
        ref = ref.limit(payload.limit);
      }

      return bindFirestoreRef('records', ref);
    }),
    getPaginationPois({ commit, state }, payload) {
      return db
        .collection('pois')
        .where('validated', '==', true)
        .orderBy('geojson.properties.taken_at', 'desc')
        .limit(state.pagination.itemCount)
        .get()
        .then(snapshots => {
          if (!snapshots.docs.length) {
            commit('SET_PAGINATION_END', true);
            return [];
          }
          if (!payload.loggedIn) {
            commit('SET_PAGINATION_END', true);
          } else {
            commit('SET_PAGINATION_END', false);
          }
          const pois = snapshots.docs.map(doc => ({ ...doc.data(), id: doc.id }));
          commit('SET_PAGINATION_POIS', { pois, first: true });
          commit('SET_PAGINATION_LAST_ITEM', snapshots.docs[snapshots.docs.length - 1]);
          return pois;
        });
    },
    getPaginationPoisNext({ commit, state }) {
      if (state.pagination.loading) return;
      let query;
      commit('SET_PAGINATION_IS_LOADING', true);
      query = db
        .collection('pois')
        .where('validated', '==', true)
        .orderBy('geojson.properties.taken_at', 'desc')
        .startAfter(state.pagination.lastItem);

      return query
        .limit(state.pagination.itemCount)
        .get()
        .then(snapshots => {
          commit('SET_PAGINATION_IS_LOADING', false);
          if (!snapshots.docs.length) {
            commit('SET_PAGINATION_END', true);
            return [];
          }
          const pois = snapshots.docs.map(doc => ({ ...doc.data(), id: doc.id }));
          commit('SET_PAGINATION_POIS', { pois, first: false });
          commit('SET_PAGINATION_LAST_ITEM', snapshots.docs[snapshots.docs.length - 1]);
          return pois;
        });
    },
    getCarouselPois({ commit }, payload) {
      db.collection('pois')
        .where('validated', '==', true)
        .where('geojson.properties.categories', 'array-contains-any', [payload.category])
        .orderBy('geojson.properties.taken_at', 'desc')
        .limit(5)
        .get()
        .then(snapshots => {
          const pois = snapshots.docs.map(doc => ({ ...doc.data(), id: doc.id }));
          commit('SET_CAROUSEL_POIS', { pois, category: payload.category });
          return true;
        });
    },
    paginationReset({ commit }) {
      commit('PAGINATION_RESET');
    },
  },
  getters: {
    panoramas(state) {
      return state.carousel.panorama.records;
    },
    record(state) {
      return state.record;
    },
    records(state) {
      return state.records;
    },
    paginationEnd(state) {
      return state.pagination.end;
    },
    paginationLoading(state) {
      return state.pagination.loading;
    },
  },
  mutations: {
    PAGINATION_RESET(state) {
      state.pagination.end = false;
      state.pagination.lastItem = null;
    },
    SET_CAROUSEL_POIS(state, data) {
      state.carousel[data.category].records = data.pois;
    },
    SET_PAGINATION_END(state, status) {
      state.pagination.end = status;
    },
    SET_PAGINATION_LAST_ITEM(state, item) {
      state.pagination.lastItem = item;
    },
    SET_PAGINATION_POIS(state, data) {
      if (data.first) {
        state.records = data.pois;
      } else {
        data.pois.forEach(poi => {
          state.records.push(poi);
        });
      }
    },
    SET_PAGINATION_IS_LOADING(state, loading) {
      state.pagination.loading = loading;
    },
  },
};
